import { useMemo } from 'react';
import { useAuth } from 'context/AuthContext';
import { useSensorGroups } from 'context/SensorGroupsContext';
export const useUserSensorGroups = () => {
    const { currentUser } = useAuth();
    const { sensorGroups } = useSensorGroups();
  const userGroupNames = useMemo(() => {
    if (
      !currentUser?.data?.group ||
      !Array.isArray(currentUser.data.group) ||
      !sensorGroups ||
      !Array.isArray(sensorGroups)
    ) {
      return [];
    }
    const userGroupIds = currentUser.data.group;
    const userGroupIdSet = new Set(userGroupIds);
    const filteredAndMappedGroups = sensorGroups
      .filter((group) => userGroupIdSet.has(group.id))
      .map((group) => group.name);

    return filteredAndMappedGroups;
  }, [currentUser, sensorGroups]);
  return userGroupNames;
};
